<header
  class="site-header"
  id="backtoTop"
>
  <!-- Menú responsive -->
  <div class="tal logos-area">
    <button
      (click)="lanzar()"
      class="hamburger hamburger--spin onlyMobile"
      type="button"
    >
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
    <div class="logos-wrap">
      <a
        [routerLink]="['/home/home']"
        class="nav-link"
        href="#"
        #input
        title="Volver a inicio"
      >
        <img
          src="assets/images/LogosOficinas/{{logo}}"
          class="logo valoriza"
          alt="{{site}}"
        />
      </a>
      <a
        [routerLink]="['/home/home']"
        class="nav-link"
        href="#"
        title="Volver a inicio"
      >
        <img
          src="assets/images/logo-ov.svg"
          class="logo oficina"
          alt="Oficina Virtual"
        />
      </a>
    </div>
  </div>
  <div class="login-top">
    <div class="login-top__usuario">
      <span class="login-top__usuario__text">
        <span class="sr-only">Usuario:</span>{{ UserName }}</span>
      <a
        [routerLink]="['/home/usuario']"
        class="nav-link"
        title=""
      >
        <span class="icono-img">
          <img
            src="assets/images/icons/user.svg"
            class="login-icon"
          >
        </span>
      </a>
    </div>
    <div class="login-top__logout">
      <span class="sr-only">Salir</span>
      <a
        class="nav-link"
        title=""
      >
        <span class="icono-img">
          <img
            (click)="logout()"
            src="assets/images/icons/salir.svg"
            class="login-icon"
          >
        </span>
      </a>
    </div>
  </div>
</header>
